import { render } from "./thinktankDetail.vue?vue&type=template&id=a8ed356e&scoped=true"
import script from "./thinktankDetail.vue?vue&type=script&lang=js"
export * from "./thinktankDetail.vue?vue&type=script&lang=js"

import "./thinktankDetail.vue?vue&type=style&index=0&id=a8ed356e&lang=less&scoped=true"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8ed356e"]])

export default __exports__